import { render, staticRenderFns } from "./Thanku.vue?vue&type=template&id=66896586&"
import script from "./Thanku.vue?vue&type=script&lang=js&"
export * from "./Thanku.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports